'use client';

import { useEffect } from 'react';
import { Icon, Text } from '@weareconceptstudio/core';
import StickyDeliveryDropdown from '@/modules/Home/components/Hero/DeliveryBar/StickyDeliveryDropdown';
import { useFulfillmentChips } from '../FulfillmentChips/useFulfillmentChips';

const ShopFulfillmentBar = ({ globalData }) => {
	const {
		isVisible,
		isTakeaway,
		hasFulfillmentSelection,
		locationLabel,
		timeLabel,
	} = useFulfillmentChips({ compact: true, iconOnly: false, promptOnShopEnter: true });

	useEffect(() => {
		window.dispatchEvent(new Event('resize'));
	}, [hasFulfillmentSelection]);

	if (!isVisible) return null;

	const initialTab = isTakeaway ? 'takeaway' : 'delivery';
	const barClassName = hasFulfillmentSelection
		? 'is-shop-fulfillment-bar has-fulfillment-selection'
		: 'is-shop-fulfillment-bar';

	return (
		<StickyDeliveryDropdown
			globalData={globalData}
			initialTab={initialTab}
			className={barClassName}
			trigger={({ isOpen, togglePanel }) =>
				hasFulfillmentSelection ? (
					<button
						type='button'
						className='fulfillment-sticky-trigger'
						aria-expanded={isOpen}
						onClick={togglePanel}>
						<Text
							className='p p4 font-montserrat-arm-regular fulfillment-sticky-type'
							text={isTakeaway ? 'deliveryTemplate.takeawayTab' : 'deliveryTemplate.deliveryTab'}
						/>
						<span className='fulfillment-sticky-row'>
							<Icon
								name='location'
								className='fulfillment-sticky-pin'
							/>
							<span className='fulfillment-sticky-location font-montserrat-arm-medium'>
								{locationLabel || '—'}
							</span>
							{timeLabel && (
								<>
									<span
										className='fulfillment-sticky-separator'
										aria-hidden
									/>
									<span className='fulfillment-sticky-time font-montserrat-arm-regular'>
										{timeLabel}
									</span>
								</>
							)}
							<Icon
								name='right-arrow'
								className={`fulfillment-sticky-chevron icon-arrow ${isOpen ? 'is-open' : ''}`}
							/>
						</span>
					</button>
				) : (
					<button
						type='button'
						className='fulfillment-sticky-trigger is-home-style'
						aria-expanded={isOpen}
						onClick={togglePanel}>
						<Icon
							name='location'
							className='fulfillment-sticky-pin'
						/>
						<span className='fulfillment-sticky-location font-montserrat-arm-regular'>{locationLabel}</span>
						<Icon
							name='right-arrow'
							className={`fulfillment-sticky-chevron icon-arrow ${isOpen ? 'is-open' : ''}`}
						/>
					</button>
				)
			}
		/>
	);
};

export default ShopFulfillmentBar;
